module.exports = __webpack_public_path__ + "img/bg_avatar_male_46.d0317243.png";